import { render, staticRenderFns } from "./trendyolinfo.vue?vue&type=template&id=15ccd35c&scoped=true"
import script from "./trendyolinfo.ts?vue&type=script&lang=js&external"
export * from "./trendyolinfo.ts?vue&type=script&lang=js&external"
import style0 from "./trendyolinfo.vue?vue&type=style&index=0&id=15ccd35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ccd35c",
  null
  
)

export default component.exports